<template>
  <div id="app">
    <alert></alert>
    <!--  :key="$route.fullPath.replace('/reserve', '')" -->
    <keep-alive :max="2" :include="include">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'App',
  components: {},
  computed: {
    include() {
      const routeNm = this.$route.name;
      //리스트에서 접근시 캐시 제거를 위해
      if (routeNm === 'Grp product list' || routeNm === 'Ind product list') {
        return ['ProductMainView'];
      } else if (routeNm === 'grp' || routeNm === 'ind') {
        return ['ProductDetailView'];
      } else {
        return ['ProductMainView', 'ProductDetailView'];
      }
    },
  },
  methods: {
    ...mapActions(['checkUserLogin']),
  },
  created() {
    //this.checkUserLogin();
    if (this.isMobileSafari) {
      window.alert = (msg) => this.$alert.present('알림', msg, [{ title: '확인', type: 'cancel' }]);
      window.customConfirm = (msg, callback) => {
        this.$alert.present('확인', msg, [
          { title: '취소', type: 'normal', handler: () => callback(false) },
          { title: '확인', type: 'normal', handler: () => callback(true) },
        ]);
      };
    } else {
      window.customConfirm = (msg, callback) => {
        if (confirm(msg)) {
          callback(true);
        } else {
          callback(false);
        }
      };
    }

    // window.confirm = (msg, callback) => {
    //   if (this.isMobileSafari) {
    //     this.$alert.present('알림', msg, [{ title: '확인', type: 'cancel' }]);
    //   } else {
    //     if(window.browserConfirm(msg)){

    //     }
    //     return ;
    //   }
    // };
  },
  updated() {},
};
</script>

<style lang="scss">
@import '@/assets/css/common.css';
@import '@/assets/css/common_etc.css';
@import '@/assets/css/layout.css';
@import '@/assets/css/sub.css';

html,
body {
  height: 100%;
}
</style>
